import React, { Fragment } from "react";
import TextInput from "../inputs/text-input";
import SelectFieldComboField from "../inputs/select-field-combo/select-field-combo-field";

const GarmentInformation = (props) => {
  const { form, register, errors, setSelectValue, jPath, updateOptionsAllowed, setOnFocus } = props;

  const colors = form.garment.sf.colorDropdown.selOptions;
  colors.sort((a, b) => a.value.localeCompare(b.value));

  return (
    <Fragment>
      <div className="field-creator__field-container">
        <SelectFieldComboField
          register={register}
          setSelectValue={(name, value) => {
            updateOptionsAllowed(value[0]);
            setSelectValue(name, value);
          }}
          path={`${jPath}.product_type`}
          name={`${form.garment.sf.product_type.name}`}
          selOptions={form.garment.sf.product_type.selOptions ?? []}
          errors={errors}
        />
      </div>
      <div className="field-creator__field-container">
        <SelectFieldComboField
          register={register}
          setSelectValue={(name, value) => {
            setSelectValue(name, value);
          }}
          path={`${jPath}.condition`}
          name={form.garment.sf.condition.name}
          selOptions={form.garment.sf.condition.selOptions ?? []}
          errors={errors}
        />
      </div>
      <div className="field-creator__field-container">
        <SelectFieldComboField
          register={register}
          setSelectValue={(name, value) => {
            setSelectValue(name, value);
          }}
          path={`${jPath}.color_dropdown`}
          name={form.garment.sf.colorDropdown.name}
          selOptions={colors ?? []}
          errors={errors}
        />
      </div>
      <div style={{ display: "none" }}>
        <TextInput
          path={`${jPath}.color.value`}
          name={form.garment.sf.color.name}
          register={register}
          errors={errors}
          setOnFocus={setOnFocus}
        />
      </div>
      <TextInput
        path={`${jPath}.material.value`}
        name={form.garment.sf.material.name}
        register={register}
        errors={errors}
        setOnFocus={setOnFocus}
      />
    </Fragment>
  );
};

export default GarmentInformation;
